import { View } from '@react-pdf/renderer'

import CarBodyScheme from './CarBodyScheme'
import PartStateIcon from './PartStateIcon'

export default function CarBodyDetails({
  inspectionExternalPurch = {},
  carBodySchemeWidth,
  carBodySchemeHeight
}) {
  const {
    capote,
    doorstepRight,
    doorstepLeft,
    roof,
    trunk,
    wingFrontLeft,
    wingRearLeft,
    doorFrontLeft,
    doorRearLeft,
    rackFrontLeft,
    rackCentralLeft,
    rackRearLeft,
    wingFrontRight,
    wingRearRight,
    doorFrontRight,
    doorRearRight,
    rackFrontRight,
    rackCentralRight,
    rackRearRight
  } = inspectionExternalPurch

  return (
    <View
      style={{
        position: 'relative'
      }}
    >
      <CarBodyScheme width={carBodySchemeWidth} height={carBodySchemeHeight} />

      {capote && (
        <View style={{ position: 'absolute', top: '15%', left: '47%' }}>
          <PartStateIcon state={capote?.state} paint={capote?.paintThickness} />
        </View>
      )}

      {roof && (
        <View style={{ position: 'absolute', top: '53%', left: '47%' }}>
          <PartStateIcon
            isPanorama={roof?.isPanorama}
            state={roof?.state}
            paint={roof?.paintThickness}
          />
        </View>
      )}

      {trunk && (
        <View style={{ position: 'absolute', top: '81%', left: '47%' }}>
          <PartStateIcon state={trunk?.state} paint={trunk?.paintThickness} />
        </View>
      )}

      {doorFrontLeft && (
        <View style={{ position: 'absolute', top: '41%', left: '13.6%' }}>
          <PartStateIcon
            state={doorFrontLeft?.state}
            paint={doorFrontLeft?.paintThickness}
          />
        </View>
      )}

      {doorRearLeft && (
        <View style={{ position: 'absolute', top: '60%', left: '13.6%' }}>
          <PartStateIcon
            state={doorRearLeft?.state}
            paint={doorRearLeft?.paintThickness}
          />
        </View>
      )}

      {wingFrontLeft && (
        <View style={{ position: 'absolute', top: '23%', left: '18%' }}>
          <PartStateIcon
            isPlastic={wingFrontLeft?.isPlastic}
            state={wingFrontLeft?.state}
            paint={wingFrontLeft?.paintThickness}
          />
        </View>
      )}

      {wingRearLeft && (
        <View style={{ position: 'absolute', top: '79%', left: '20%' }}>
          <PartStateIcon
            state={wingRearLeft?.state}
            paint={wingRearLeft?.paintThickness}
          />
        </View>
      )}

      {rackFrontLeft && (
        <View style={{ position: 'absolute', top: '35%', left: '27.6%' }}>
          <PartStateIcon
            state={rackFrontLeft?.state}
            paint={rackFrontLeft?.paintThickness}
          />
        </View>
      )}

      {rackCentralLeft && (
        <View style={{ position: 'absolute', top: '51.9%', left: '26.7%' }}>
          <PartStateIcon
            state={rackCentralLeft?.state}
            paint={rackCentralLeft?.paintThickness}
          />
        </View>
      )}

      {rackRearLeft && (
        <View style={{ position: 'absolute', top: '69%', left: '28%' }}>
          <PartStateIcon
            state={rackRearLeft?.state}
            paint={rackRearLeft?.paintThickness}
          />
        </View>
      )}

      {doorFrontRight && (
        <View style={{ position: 'absolute', top: '41%', right: '13.6%' }}>
          <PartStateIcon
            state={doorFrontRight?.state}
            paint={doorFrontRight?.paintThickness}
          />
        </View>
      )}

      {doorRearRight && (
        <View style={{ position: 'absolute', top: '60%', right: '13.6%' }}>
          <PartStateIcon
            state={doorRearRight?.state}
            paint={doorRearRight?.paintThickness}
          />
        </View>
      )}

      {wingFrontRight && (
        <View style={{ position: 'absolute', top: '23%', left: '76%' }}>
          <PartStateIcon
            isPlastic={wingFrontRight?.isPlastic}
            state={wingFrontRight?.state}
            paint={wingFrontRight?.paintThickness}
          />
        </View>
      )}

      {wingRearRight && (
        <View style={{ position: 'absolute', top: '79%', right: '20%' }}>
          <PartStateIcon
            state={wingRearRight?.state}
            paint={wingRearRight?.paintThickness}
          />
        </View>
      )}

      {rackFrontRight && (
        <View style={{ position: 'absolute', top: '35%', right: '27.6%' }}>
          <PartStateIcon
            state={rackFrontRight?.state}
            paint={rackFrontRight?.paintThickness}
          />
        </View>
      )}

      {rackCentralRight && (
        <View style={{ position: 'absolute', top: '51.9%', right: '26.7%' }}>
          <PartStateIcon
            state={rackCentralRight?.state}
            paint={rackCentralRight?.paintThickness}
          />
        </View>
      )}

      {rackRearRight && (
        <View style={{ position: 'absolute', top: '69%', right: '28%' }}>
          <PartStateIcon
            state={rackRearRight?.state}
            paint={rackRearRight?.paintThickness}
          />
        </View>
      )}

      {doorstepLeft && (
        <View style={{ position: 'absolute', top: '53%', left: '7%' }}>
          <PartStateIcon
            state={doorstepLeft?.state}
            paint={doorstepLeft?.paintThickness}
          />
        </View>
      )}

      {doorstepRight && (
        <View style={{ position: 'absolute', top: '53%', right: '7%' }}>
          <PartStateIcon
            state={doorstepRight?.state}
            paint={doorstepRight?.paintThickness}
          />
        </View>
      )}
    </View>
  )
}
